export default "__VITE_ASSET__BzhYKKs6__"